export enum MissingKycValues {
	PurposeOfLoan = 'PurposeOfLoan',
	PEP = 'PEP',
	PurposeOfLoanOther = 'PurposeOfLoanOther',
	ConnectedToPep = 'ConnectedToPep',
}